import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {EAddToCartType} from 'coreStore/data/ui/types';

import Button from 'brandComponents/Button';

import {AddToCartButtonMode, IAddToCartButtonProps} from './IAddToCartButton';
import messages from './messages';

const AddToCartButton = ({
	onClick,
	mode,
	classNames,
	label = '',
	variant,
	disabled = false,
	loading = false,
}: IAddToCartButtonProps) => {
	const intl = useIntl();

	const handleClick = () => {
		if (mode === AddToCartButtonMode.ADD_TO_CART || mode === AddToCartButtonMode.PREORDER_NOW) {
			onClick(EAddToCartType.ADD_TO_CART);
		} else {
			onClick(EAddToCartType.BUY_NOW);
		}
	};

	return (
		<Button
			classNames={cn('product_buy_button', classNames, mode)}
			variant={variant}
			onClick={handleClick}
			disabled={disabled || loading}
			loading={loading}
		>
			{label || intl.formatMessage(messages[mode])}
		</Button>
	);
};

export default AddToCartButton;
